import { graphql } from "relay-runtime"

export const chDeleteBodyMeasurementMutation = graphql`
  mutation chDeleteBodyMeasurementMutation($input: Ch_deleteBodyMeasurementInput!, $connections: [ID!]!) {
    deleteBodyMeasurement: ch_deleteBodyMeasurement(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      bodyMeasurement {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
